// demo popup start
document.addEventListener('DOMContentLoaded', function () {
  const modal = document.getElementById('demo-modal');
  const openButtons = document.querySelectorAll('[data-open-demo-modal]');
  const closeButtons = document.querySelectorAll('[data-close-demo-modal]');
  const dialog = modal?.querySelector('.demo-modal__dialog');

  if (!modal) return;

  const openModal = function () {
    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('modal-open');
  };

  const closeModal = function () {
    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('modal-open');
  };

  openButtons.forEach(function (button) {
    button.addEventListener('click', function (event) {
      if (button.tagName.toLowerCase() === 'a') {
        event.preventDefault();
      }

      openModal();
    });
  });

  closeButtons.forEach(function (button) {
    button.addEventListener('click', closeModal);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape' && modal.classList.contains('is-open')) {
      closeModal();
    }
  });

  modal.addEventListener('click', function (event) {
    if (!dialog) return;

    if (!dialog.contains(event.target)) {
      closeModal();
    }
  });
});
// demo popup end